<template>
  <div style="width: 100%;height:100%">
    <div
      class="main-image"
      :style="{backgroundImage: 'url(' + image + ')' }"
      :class="{blue:blue}"
    >
      <!-- <img
        :src="image"
        alt=""
      > -->
      <div
        v-if="edit"
        class="change-button-wrap"
      >
        <UploadImageButton
          v-model="uploadImagefile"
          arc-button
          :upload-url="uploadUrl"
          @input="fileChange()"
        />
        <i
          class="cancel icon-cancel"
          @click="deleteImage()"
        />
        <div class="bg" />
      </div>
      <div
        v-else
        class="zoom-in-wrap"
        @click="previewOpen()"
      >
        <i class="icon-zoom-in" />
        <div class="bg" />
      </div>
    </div>
    <PreviewPopUp
      :text-label="image"
      download
      :pop-up-active="previewActive"
      @click="previewClose()"
    />
  </div>
</template>
<script>
export default {
  name: "MainImage",
  props: {
    image: {
      type: String,
      default: "",
    },
    edit: {
      type: Boolean,
      default: false,
    },
    load: {
      type: Boolean,
      default: false,
    },
    tabletNarrow: {
      type: Boolean,
      default: false,
    },
    blue: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    uploadUrl: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    previewActive: false,
    uploadImagefile: "",
    range: 0,
  }),
  methods: {
    previewOpen() {
      this.previewActive = true;
      this.$emit("input", true);
    },
    previewClose() {
      this.previewActive = false;
      this.$emit("input", false);
    },
    fileChange() {
      this.$emit("input", this.uploadImagefile);
    },
    deleteImage() {
      this.uploadImagefile = "";
      this.fileChange();
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/main-image";
</style>